// These variables are used to override the styles of the pins and clusters.
export const CSS_VARS = {
  PIN_STORE_BACKGROUND: '--pin-background',
  PIN_STORE_FOREGROUND: '--pin-foreground',
  PIN_STORE_BORDER: '--pin-border',
  PIN_STORE_SELECTED_BACKGROUND: '--pin-selected-background',
  PIN_STORE_SELECTED_FOREGROUND: '--pin-selected-foreground',
  PIN_STORE_SELECTED_BORDER: '--pin-selected-border',
  PIN_CLUSTER_BACKGROUND: '--pin-cluster-background',
  PIN_CLUSTER_FOREGROUND: '--pin-cluster-foreground',
  PIN_CLUSTER_BORDER: '--pin-cluster-border',
}

export const COLOR = {
  WHITE: "#FFFFFF",
  TRANSPARENT: "#00000000",
  VY_GREEN: "#1CC282",
  VY_WHITE: "#f5f5f5",
  VY_BLACK: "#1C1A20",
  VY_LIGHT_GREY: "#E6E6E6",
  VY_LILAC: "#D2A7FF",
  VY_RED: "#FF3800",

  // DELIVERY SERVICES
  LIEFERANDO: "#FF8000",
  WOLT: "#65BEE2",
  HAB_GUSTA: "#ff6158",
  EATIC: "#355a5e",
  MJAM: "#2EFF55",
  FOOD_PANDA: "#d70f64",

  // OVERLAY
  OVERLAY_60: "#00000099",

  // ADDED TO FIGMA FOR LEGACY
  GREY_DARK: "#2B363E",

  // CUSTOM PIN COLORS
  PIN_STORE_BACKGROUND: `var(${CSS_VARS.PIN_STORE_BACKGROUND}, #D2A7FF)`, // VY_LILAC
  PIN_STORE_FOREGROUND: `var(${CSS_VARS.PIN_STORE_FOREGROUND}, #1C1A20)`, // VY_BLACK
  PIN_STORE_BORDER: `var(${CSS_VARS.PIN_STORE_BORDER}, #D2A7FF)`, // VY_LILAC
  PIN_STORE_SELECTED_BACKGROUND: `var(${CSS_VARS.PIN_STORE_SELECTED_BACKGROUND}, #1CC282)`, // VY_GREEN
  PIN_STORE_SELECTED_FOREGROUND: `var(${CSS_VARS.PIN_STORE_SELECTED_FOREGROUND}, #1C1A20)`, // VY_BLACK
  PIN_STORE_SELECTED_BORDER: `var(${CSS_VARS.PIN_STORE_SELECTED_BORDER}, #1CC282)`, // VY_GREEN

  PIN_CLUSTER_BACKGROUND: `var(${CSS_VARS.PIN_CLUSTER_BACKGROUND}, #FFFFFF)`, // WHITE
  PIN_CLUSTER_FOREGROUND: `var(${CSS_VARS.PIN_CLUSTER_FOREGROUND}, #1C1A20)`, // VY_BLACK
  PIN_CLUSTER_BORDER: `var(${CSS_VARS.PIN_CLUSTER_BORDER}, #FFFFFF)`, // WHITE
};

// taken from webflow
export const BREAKPOINTS = {
  mobileLandscape: 480,
  tablet: 768,
  laptop: 992,
  desktop: 1280,
};
